// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"0c111b13","553":"9c6f3a22"}[chunkId] + ".chunk.css";
};